import React from "react";
import { Modal } from "antd";

const PreviewImage = ({ previewVisible, setPreviewVisible, previewImage }) => {
  return (
    <Modal
      style={{ borderRadius: 13 }}
      bodyStyle={{ padding: 10 }}
      visible={previewVisible}
      title="Image Preview"
      footer={null}
      onCancel={() => setPreviewVisible(false)}
    >
      <img alt="example" style={{ width: "100%" }} src={previewImage} />
    </Modal>
  );
};

export default PreviewImage;
